import moment from 'moment';

export function formatIsoDate(date) {
  return moment(date).format('YYYY-MM-DD');
}

export function formatIsoDateTime(datetime) {
  return moment(datetime).format('YYYY-MM-DDTHH:mm:ssZZ');
}

export function datetimeReadable(datetime) {
  return moment(datetime).utc().format('MMM Do YYYY, h:mm:ss A');
}

export function now() {
  return moment.utc();
}



// WEBPACK FOOTER //
// ./utils/dates.js